module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/5/1-9042c9bbaacfe48905d9fa053a3366f1.jpg";